// import React, { useEffect, useState } from 'react'
// import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

// export default function AutoCompleteAddress({
//   formik = {},
//   address,
//   setAddress,
//   location,
//   setlocation,
// }) {
//   return (
//     <LocationInput
//       formik={formik}
//       address={address}
//       setAddress={setAddress}
//       location={location}
//       setlocation={setlocation}
//     />
//   )
// }

// function LocationInput({ address, formik, setAddress, location, setlocation }: any) {





//   useEffect(() => {
//     // Create style element for placeholder
//     const style = document.createElement('style');
//     style.textContent = `
//       .location-search-input::placeholder {
//         color: black !important;
//         opacity: 1 !important;
//       }
//       .location-search-input::-webkit-input-placeholder {
//         color: black !important;
//         opacity: 1 !important;
//       }
//       .location-search-input::-moz-placeholder {
//         color: black !important;
//         opacity: 1 !important;
//       }
//       .location-search-input:-ms-input-placeholder {
//         color: black !important;
//         opacity: 1 !important;
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);



//   const handleChangeAddress = (newAddress) => {
//     setAddress(newAddress)
//   }
//   const handleSelectAddress = (newAddress) => {
//     setAddress(newAddress)
//     geocodeByAddress(newAddress)
//       .then((results) => getLatLng(results[0]))
//       .then((latLng) => {
//         if (Object.keys(formik).length > 0) {
//           formik?.setFieldValue('longitute', parseFloat(latLng.lng))
//           // formik?.validateField('longitute')
//           setTimeout(() => {
//             formik?.setFieldValue('latitute', parseFloat(latLng.lat))
//           }, 500)

//           // trigger validation for specific field
//           // formik.validateField('latitute')
//         }
//         setlocation(latLng)
//       })
//       .catch((error) => console.error('Error', error))
//   }
//   return (
//     <PlacesAutocomplete
//       value={address}
//       onChange={handleChangeAddress}
//       onSelect={handleSelectAddress}
//     >
//       {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
//         <div>
//           <style>
//             {`
//       .location-search-input::placeholder {
//         color: #999 !important;
//         opacity: 1 !important;
//       }
//       .location-search-input::-webkit-input-placeholder {
//         color: #999 !important;
//         opacity: 1 !important;
//       }
//       .location-search-input::-moz-placeholder {
//         color: #999 !important;
//         opacity: 1 !important;
//       }
//       .location-search-input:-ms-input-placeholder {
//         color: #999 !important;
//         opacity: 1 !important;
//       }
//     `}
//           </style>
//           <input
//             {...getInputProps({
//               placeholder: 'Search Places ...',
//               className: 'location-search-input form-control mb-3 mb-lg-0',
//               style: {
//                 backgroundColor: 'white',
//                 border: '1px solid #cdcdcd',
//                 color: 'black'
//               }
//             })}
//           />
//           <div className='autocomplete-dropdown-container'>
//             {loading && <div>Loading...</div>}
//             {suggestions.map((suggestion) => {
//               const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
//               // inline style for demonstration purpose
//               const style = suggestion.active
//                 ? { backgroundColor: '#fafafa', cursor: 'pointer' }
//                 : { backgroundColor: '#ffffff', cursor: 'pointer' }
//               return (
//                 <div
//                   className='form-control form-control-solid mb-3 mb-lg-0'
//                   key={suggestion.placeId}
//                   {...getSuggestionItemProps(suggestion, {
//                     className,
//                     style,
//                   })}
//                 >
//                   <span>{suggestion.description}</span>
//                 </div>
//               )
//             })}
//           </div>
//         </div>
//       )}
//     </PlacesAutocomplete>
//   )
// }




import React, { useEffect, useState } from 'react'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

export default function AutoCompleteAddress({
  formik = {},
  address,
  setAddress,
  location,
  setlocation,
}) {
  return (
    <LocationInput
      formik={formik}
      address={address}
      setAddress={setAddress}
      location={location}
      setlocation={setlocation}
    />
  )
}

function LocationInput({ address, formik, setAddress, location, setlocation }: any) {
  useEffect(() => {
    // Create style element for placeholder
    const style = document.createElement('style');
    style.textContent = `
      .location-search-input::placeholder {
        color: black !important;
        opacity: 1 !important;
      }
      .location-search-input::-webkit-input-placeholder {
        color: black !important;
        opacity: 1 !important;
      }
      .location-search-input::-moz-placeholder {
        color: black !important;
        opacity: 1 !important;
      }
      .location-search-input:-ms-input-placeholder {
        color: black !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handleChangeAddress = (newAddress) => {
    setAddress(newAddress)
  }

  const handleSelectAddress = (newAddress) => {
    setAddress(newAddress)
    geocodeByAddress(newAddress)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        if (Object.keys(formik).length > 0) {
          formik?.setFieldValue('longitute', parseFloat(latLng.lng))
          setTimeout(() => {
            formik?.setFieldValue('latitute', parseFloat(latLng.lat))
          }, 500)
        }
        setlocation(latLng)
      })
      .catch((error) => console.error('Error', error))
  }

  return (
    <PlacesAutocomplete
      value={address}
      onChange={handleChangeAddress}
      onSelect={handleSelectAddress}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          <style>
            {`
      .location-search-input::placeholder {
        color: #999 !important;
        opacity: 1 !important;
      }
      .location-search-input::-webkit-input-placeholder {
        color: #999 !important;
        opacity: 1 !important;
      }
      .location-search-input::-moz-placeholder {
        color: #999 !important;
        opacity: 1 !important;
      }
      .location-search-input:-ms-input-placeholder {
        color: #999 !important;
        opacity: 1 !important;
      }
    `}
          </style>

          {/* Separate container for input + image */}
          <div style={{ position: 'relative', marginBottom: '0' }}>
            <input
              {...getInputProps({
                placeholder: 'Search Places ...',
                className: 'location-search-input form-control mb-3 mb-lg-0',
                style: {
                  backgroundColor: 'white',
                  border: '1px solid #cdcdcd',
                  color: 'black',
                  paddingRight: '40px',
                  marginBottom: '0'
                }
              })}
            />
            <img
              src="/Digitise your business (5).png"
              alt="Location"
              style={{
                position: 'absolute',
                right: '10px',
                top: '45%',
                transform: 'translateY(-50%)',
                width: '90px',
                height: '50px',
                pointerEvents: 'none'
              }}
            />
          </div>

          {/* Separate container for dropdown */}
          <div className='autocomplete-dropdown-container'>
            {loading && <div>Loading...</div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
              const style = suggestion.active
                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                : { backgroundColor: '#ffffff', cursor: 'pointer' }
              return (
                <div
                  className='form-control form-control-solid mb-3 mb-lg-0'
                  key={suggestion.placeId}
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  )
}